import React from "react";
import { motion } from "framer-motion";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Marta Fernandes",
    role: "Mãe de aluna do 9º ano",
    text: "A diferença foi notória em poucos meses. A minha filha ganhou método, confiança e voltou a gostar de estudar. O acompanhamento é próximo e humano.",
  },
  {
    name: "João Pereira",
    role: "Aluno — 12º ano",
    text: "As explicações em pequeno grupo ajudaram-me imenso a Matemática e Físico-Química. Cheguei aos exames nacionais preparado e tranquilo.",
  },
  {
    name: "Rita Almeida",
    role: "Estudante universitária",
    text: "Tive apoio em Cálculo no 1º ano de Engenharia. Os professores explicam com paciência e a sala de estudo é o ambiente que eu precisava.",
  },
  {
    name: "Ana Sousa",
    role: "Mãe de aluno do 6º ano",
    text: "Procurávamos um sítio que cuidasse também da parte emocional. As sessões de wellbeing fizeram toda a diferença no meu filho.",
  },
  {
    name: "Pedro Costa",
    role: "Aluno Cambridge B2 First",
    text: "Preparei-me para o FCE em poucos meses e passei com Grade A. A metodologia é séria e o ambiente é fantástico.",
  },
  {
    name: "Sofia Ribeiro",
    role: "Mãe de aluna do 11º ano",
    text: "Equipa profissional, comunicação constante connosco e resultados visíveis. Recomendo sem reservas.",
  },
];

export const Testimonials = () => {
  return (
    <section id="testemunhos" data-testid="testimonials-section" className="section bg-white">
      <div className="container-tight">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Testemunhos</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
              O que dizem <span className="italic text-bordeaux-700">alunos e famílias.</span>
            </h2>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((t, i) => (
                <CarouselItem key={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div data-testid={`testimonial-${i}`} className="h-full p-7 rounded-2xl bg-stone-50/70 border border-stone-100 hover:border-bordeaux-200 transition-all flex flex-col">
                    <Quote className="text-bordeaux-700/40" size={32} />
                    <p className="mt-4 text-stone-700 leading-relaxed flex-1">{t.text}</p>
                    <div className="mt-6 flex items-center gap-1 text-gold mb-3">
                      {[...Array(5)].map((_, k) => <Star key={k} size={14} fill="currentColor" strokeWidth={0} />)}
                    </div>
                    <div className="border-t border-stone-200 pt-4">
                      <div className="font-semibold text-stone-900">{t.name}</div>
                      <div className="text-xs text-stone-500 mt-0.5">{t.role}</div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex items-center justify-end gap-3 mt-8">
              <CarouselPrevious data-testid="testimonials-prev" className="static translate-y-0 h-11 w-11 border-stone-300 hover:border-bordeaux-700 hover:bg-bordeaux-700 hover:text-white" />
              <CarouselNext data-testid="testimonials-next" className="static translate-y-0 h-11 w-11 border-stone-300 hover:border-bordeaux-700 hover:bg-bordeaux-700 hover:text-white" />
            </div>
          </Carousel>
        </motion.div>
      </div>
    </section>
  );
};
